module.exports = __webpack_public_path__ + "img/7bb3507.jpg";